/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CampaignQuanZhongLeiXing,
  ResponseApiCampaignQuanZhongLeiXing,
  ResponseApiListCampaignQuanZhongLeiXing,
  ResponseApiLong,
  ResponseApiVoid,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class CampaignQuanZhongLeiXingPeiZhiGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags CampaignQuanZhongLeiXingPeiZhiGuanLi
   * @name GetAllWeightTypesUsingGet
   * @summary 获取所有权重类型列表
   * @request GET:/dsp-admin/api/campaign-weight-type
   * @secure
   */
  getAllWeightTypesUsingGet = (params: RequestParams = {}) =>
    this.request<ResponseApiListCampaignQuanZhongLeiXing, void>({
      path: `/dsp-admin/api/campaign-weight-type`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags CampaignQuanZhongLeiXingPeiZhiGuanLi
   * @name CreateWeightTypeUsingPost
   * @summary 创建权重类型
   * @request POST:/dsp-admin/api/campaign-weight-type
   * @secure
   */
  createWeightTypeUsingPost = (
    dto: CampaignQuanZhongLeiXing,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/campaign-weight-type`,
      method: "POST",
      body: dto,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CampaignQuanZhongLeiXingPeiZhiGuanLi
   * @name GetEnabledWeightTypesUsingGet
   * @summary 获取所有启用的权重类型列表
   * @request GET:/dsp-admin/api/campaign-weight-type/enabled
   * @secure
   */
  getEnabledWeightTypesUsingGet = (params: RequestParams = {}) =>
    this.request<ResponseApiListCampaignQuanZhongLeiXing, void>({
      path: `/dsp-admin/api/campaign-weight-type/enabled`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags CampaignQuanZhongLeiXingPeiZhiGuanLi
   * @name GetWeightTypeByIdUsingGet
   * @summary 根据ID获取权重类型详情
   * @request GET:/dsp-admin/api/campaign-weight-type/{id}
   * @secure
   */
  getWeightTypeByIdUsingGet = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiCampaignQuanZhongLeiXing, void>({
      path: `/dsp-admin/api/campaign-weight-type/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags CampaignQuanZhongLeiXingPeiZhiGuanLi
   * @name UpdateWeightTypeUsingPut
   * @summary 更新权重类型
   * @request PUT:/dsp-admin/api/campaign-weight-type/{id}
   * @secure
   */
  updateWeightTypeUsingPut = (
    dto: CampaignQuanZhongLeiXing,
    id?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/campaign-weight-type/${id}`,
      method: "PUT",
      body: dto,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CampaignQuanZhongLeiXingPeiZhiGuanLi
   * @name DeleteWeightTypeUsingDelete
   * @summary 删除权重类型
   * @request DELETE:/dsp-admin/api/campaign-weight-type/{id}
   * @secure
   */
  deleteWeightTypeUsingDelete = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/campaign-weight-type/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags CampaignQuanZhongLeiXingPeiZhiGuanLi
   * @name UpdateStatusUsingPut
   * @summary 启用/禁用权重类型
   * @request PUT:/dsp-admin/api/campaign-weight-type/{id}/status
   * @secure
   */
  updateStatusUsingPut = (
    id?: number,
    query?: {
      /**
       * 状态: 0-禁用, 1-启用
       * @format int32
       */
      status?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/campaign-weight-type/${id}/status`,
      method: "PUT",
      query: query,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new CampaignQuanZhongLeiXingPeiZhiGuanLi();
